var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-filter-wrapper',{attrs:{"label":_vm.$t('fields.terms_of_service_state')}},[_c('applicant-terms-of-service-state-select',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }